<template>
  <iframe ref="iframeRef" class="comunicado-cuerpo-html" :srcdoc="documentoHtml" frameborder="0" scrolling="auto" title="" @load="onIframeLoad" />
</template>

<script setup lang="ts">
import { computed, nextTick, onBeforeUnmount, ref, watch } from "vue";

const props = defineProps({
  cuerpo: {
    type: String,
    required: true,
  },
});

const iframeRef = ref<HTMLIFrameElement>();
let resizeObserver: ResizeObserver | null = null;

const documentoHtml = computed(
  () => `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;700&display=swap" rel="stylesheet">
  <style>
    html, body {
      margin: 0;
      padding: 0;
      overflow: auto;
    }

    body {
      font-family: 'Poppins', Arial, sans-serif;
      font-size: 14px;
      line-height: 1.5;
      color: #00031f;
      background: transparent;
    }

    img {
      max-width: 100%;
      height: auto;
    }
  </style>
</head>
<body>${props.cuerpo}</body>
</html>`,
);

function obtenerAlturaContenido(doc: Document): number {
  const body = doc.body;
  const html = doc.documentElement;

  return Math.max(body.scrollHeight, body.offsetHeight, html.scrollHeight, html.offsetHeight);
}

function ajustarAltura() {
  const iframe = iframeRef.value;
  const doc = iframe?.contentDocument;
  if (!iframe || !doc?.body) {
    return;
  }

  iframe.style.height = `${obtenerAlturaContenido(doc)}px`;
}

function configurarObservadores() {
  const doc = iframeRef.value?.contentDocument;
  if (!doc?.body) {
    return;
  }

  /* resizeObserver?.disconnect();
  resizeObserver = new ResizeObserver(() => ajustarAltura());
  resizeObserver.observe(doc.body);*/

  doc.querySelectorAll("img").forEach((img) => {
    if (!img.complete) {
      img.addEventListener("load", ajustarAltura, { once: true });
    }
  });
}

async function onIframeLoad() {
  ajustarAltura();
  configurarObservadores();
  await nextTick();
  ajustarAltura();
}

watch(
  () => props.cuerpo,
  async () => {
    await nextTick();
    ajustarAltura();
  },
);
/*
onBeforeUnmount(() => {
  resizeObserver?.disconnect();
});*/
</script>

<style lang="scss" scoped>
.comunicado-cuerpo-html {
  display: block;
  width: 100%;
  min-height: 1px;
}
</style>
